'use es6';

import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FlipMove from 'react-flip-move';
import { jsx as _jsx } from "react/jsx-runtime";
class MenuTree extends PureComponent {
  get classNames() {
    return classNames('simple-menus-menu-tree', this.props.parentId && 'is--subtree', this.props.isCollapsed && 'is--collapsed');
  }
  renderNodes() {
    const {
      nodes,
      depthToNextSibling,
      isParentDragging,
      getMenuComponent,
      parentId,
      moveNode,
      depth,
      menuId,
      hierarchy,
      isCollapsed,
      readOnly
    } = this.props;
    if (isCollapsed) return null;
    const MenuComponent = getMenuComponent(false);
    return nodes.map((node, index) => {
      const hasSibling = index < nodes.length - 1;
      const isLastChild = index === nodes.length - 1;
      return /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(MenuComponent, Object.assign({
          parentId: parentId,
          getMenuComponent: getMenuComponent,
          moveNode: moveNode,
          isParentDragging: isParentDragging
        }, node, {
          depth: depth,
          index: index,
          menuId: menuId,
          isLastChild: isLastChild,
          hasSibling: hasSibling,
          depthToNextSibling: hasSibling || depth === 0 ? 0 : depthToNextSibling + 1,
          hierarchy: hierarchy,
          readOnly: readOnly
        }))
      }, node.id);
    });
  }
  render() {
    return /*#__PURE__*/_jsx(FlipMove, {
      className: this.classNames,
      duration: 250,
      easing: "cubic-bezier(.42, .0, .58, 1)",
      children: this.renderNodes()
    });
  }
}
MenuTree.defaultProps = {
  isCollapsed: false,
  depthToNextSibling: 0,
  hierarchy: []
};
MenuTree.propTypes = {
  parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // replace any with node model
  nodes: PropTypes.oneOfType([PropTypes.any, PropTypes.arrayOf(PropTypes.any)]),
  getMenuComponent: PropTypes.func.isRequired,
  moveNode: PropTypes.func.isRequired,
  isParentDragging: PropTypes.bool,
  depth: PropTypes.number.isRequired,
  isCollapsed: PropTypes.bool.isRequired,
  menuId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  depthToNextSibling: PropTypes.number.isRequired,
  hierarchy: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
  readOnly: PropTypes.bool
};
export default MenuTree;